/* eslint-disable */
import videojs from 'video.js';
import './SkipForward.css';
import forwardImg from '../../assets/forward.svg';

const Button = videojs.getComponent('Button');

class SkipForward extends Button {
  constructor(player, options) {
    super(player, options);
  }

  // skip forward 5 seconds on click
  handleClick() {
    const currentTime = this.player().currentTime();
    this.player().currentTime(currentTime + 5);
  }

  createEl() {
    return videojs.dom.createEl('button', {
      className: 'vjs-custom-skip-forward-5',
      innerHTML:`<img src="${forwardImg}" />`,
    });
  }
}

// Register new SkipForward component class
videojs.registerComponent('SkipForward', SkipForward);
